import { render, staticRenderFns } from "./carInstitutionList.vue?vue&type=template&id=c0fe65dc&scoped=true"
import script from "./carInstitutionList.vue?vue&type=script&lang=js"
export * from "./carInstitutionList.vue?vue&type=script&lang=js"
import style0 from "./carInstitutionList.vue?vue&type=style&index=0&id=c0fe65dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fe65dc",
  null
  
)

export default component.exports